<template>
  <div
    class="overflow-hidden absolute top-[66px] -left-1/2 mt-2 bg-white dark:bg-[#3f1f56c3] border border-[#9857c81A] !backdrop-blur-xl rounded-xl shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 min-w-[280px]"
  >
    <!-- Multi-level dropdown (for Products) -->
    <div v-if="hasNestedItems" class="flex flex-col">
      <div class="flex">
        <div
          v-for="(category, categoryIndex) in items"
          :key="categoryIndex"
          class="flex-1 pt-4"
          :class="
            categoryIndex === 0
              ? 'border-r border-[#F0E5FF] dark:border-[#FFFFFF1A]'
              : ''
          "
        >
          <!-- Category heading -->
          <h3
            class="pl-3 text-sm font-medium text-gray-900 dark:text-white mb-1 tracking-wide"
          >
            <NuxtLink
              :to="category.link"
              class="flex items-center"
              @click="handleCloseEmit"
            >
              {{ category.label }}
            </NuxtLink>
          </h3>

          <!-- Category items -->
          <div class="space-y-1">
            <NuxtLink
              v-for="(item, itemIndex) in category.items"
              :key="itemIndex"
              :to="item.link"
              class="flex items-center gap-1 px-3 font-normal py-2 text-gray-800 dark:text-white/80 hover:bg-gray-100 dark:hover:bg-[#ffffff0d] transition-colors duration-150"
              @click="handleCloseEmit"
            >
              <!-- <component :is="item.iconURL" v-if="item.iconURL != ''" class="size-5" /> -->
              <WrSVGIcon
                v-if="item.iconURL != ''"
                :name="item.iconURL"
                class="size-5"
              />
              <span v-html="item.label"></span>
            </NuxtLink>
          </div>
        </div>
      </div>
      <NuxtLink
        class="text-sm text-gray-800 dark:text-white/80 !font-normal hover:bg-gray-100 dark:hover:bg-[#ffffff0d] text-center py-2 border-t border-[#F0E5FF] dark:border-[#FFFFFF1A] block"
        to="/products"
        @click="handleCloseEmit"
        >View All</NuxtLink
      >
    </div>

    <!-- Single-level dropdown (for Solutions, Company, etc.) -->
    <div v-else>
      <NuxtLink
        @click="handleCloseEmit"
        :target="item.link.includes('https') ? '_blank' : null"
        :rel="item.link.includes('https') ? 'noopener noreferrer' : null"
        v-for="(item, i) in items"
        :key="i"
        :to="item.link"
        :class="
          lastLink
            ? 'last:border-t border-[#F0E5FF] dark:border-[#FFFFFF1A] last:py-4'
            : ''
        "
        class="font-normal block px-4 py-3 text-gray-800 dark:text-white/80 hover:bg-gray-100 dark:hover:bg-[#ffffff0d] transition"
      >
        <span v-html="item.label"></span>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { NuxtLink } from "#components";

const props = defineProps({
  label: String,
  items: Array,
  lastLink: Boolean,
});

const emit = defineEmits(["closeDropdown"]);

const handleCloseEmit = () => {
  emit("closeDropdown");
};

const isExternal = (link) => /^https?:\/\//.test(link);

const getTag = (link) => {
  if (isExternal(link)) return "a";
  return NuxtLink;
};

// Check if items have nested structure (like Products)
const hasNestedItems = computed(() => {
  return (
    props.items &&
    props.items.length > 0 &&
    props.items[0].items &&
    Array.isArray(props.items[0].items)
  );
});
</script>
